import { render, staticRenderFns } from "./surveys-details.vue?vue&type=template&id=9ee90670&scoped=true&"
import script from "./surveys-details.vue?vue&type=script&lang=js&"
export * from "./surveys-details.vue?vue&type=script&lang=js&"
import style0 from "./surveys-details.vue?vue&type=style&index=0&id=9ee90670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee90670",
  null
  
)

component.options.__file = "surveys-details.vue"
export default component.exports